import {Group} from "./group";
export class PointImage extends Group {
  layer;
  transformer;

  constructor(layer, config) {
    super();
    this.createGroup('group-image');
    this.createImage(config);
    layer.add(this.group);
  }

  createImage(config) {
    // Вычитаем половину размера текста, чтобы элемент был поцентру курсора
    const x = config.x - config.offsetCursor;
    const y = config.y - config.offsetCursor;

      const imageObj = window.cacheImages.find(e => e.src === config.path).el;
      console.log(imageObj);
      const imageRatio = imageObj.width / imageObj.height;

      const image = new Konva.Image({
          x: x,
          y: y,
          width: 50,
          height: 50 / imageRatio,
          image: imageObj,
          name: 'point-image',
      });

      this.group.add(image);
      image.moveToBottom()


      this.group.setAttr('url', config.url);
      this.group.setAttr('slideId', config.slideId);

      this.group.on('mouseenter', function () {
          STAGE.container().style.cursor = 'pointer';
      });
      this.group.on('mouseleave', function () {
          STAGE.container().style.cursor = 'default';
      });
      this.group.on('click touchstart', (e) =>  {
          if (this.group.getAttr('slideId')) {
              KonvaController.openSlide(this.group.getAttr('slideId'))
          } else if (this.group.getAttr('url')) {
              const link = (this.group.getAttr('url').indexOf('://') === -1) ? 'http://' + this.group.getAttr('url') : this.group.getAttr('url');
              if (window.mobileCheck()) {
                  window.document.location = link;
              } else {
                  window.open(link, '_blank');
              }
          } else {
              console.log('Empty point')
          }
      });
  }


  // static setBackgroundColor(background: Konva.Text, color: string) {
  //   background.fill(color);
  // }
  //
  // static setColor(text: Konva.Text, color: string) {
  //   text.fill(color);
  // }
  //
  static setRotate(group, rotate) {
    group.getChildren().forEach(el => {
      el.rotation(rotate);
    });
  }
  static setScale(group, scaleX, scaleY) {
      group.getChildren().forEach(el => {
      if (el.name() === 'text-icon') {
       // el.setPosition({x: (el.x() - 4) + (4 * scaleX), y: (el.y() - 4) + (4 * scaleY)});
      }
      el.scaleX(scaleX);
      el.scaleY(scaleY);
    });
  }
}
